import LifecareStudioField from './LifecareStudioField';
import LifecareStudioSectionCard from './LifecareStudioSectionCard';
import { fieldRowClasses } from './lifecareStudioClasses';
import { planFieldPaths } from '../../utils/lifecarePlanUtils';

const LifecareStudioInfoSection = () => (
  <LifecareStudioSectionCard>
    <div className={fieldRowClasses}>
      <LifecareStudioField name={planFieldPaths.info('clientName')} label="Client Name" />
      <LifecareStudioField
        name={planFieldPaths.info('currentAge')}
        label="Current Age"
        type="number"
        min={0}
      />
      <LifecareStudioField
        name={planFieldPaths.info('dateOfIncident')}
        label="Date of Incident"
        placeholder="YYYY-MM-DD"
      />
    </div>
  </LifecareStudioSectionCard>
);

export default LifecareStudioInfoSection;
